import "./index.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom"; // ✅ 추가
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";
import { AuthProvider } from "./contexts/AuthContext";
import { UserProvider } from "./contexts/UserContext";
import { IntervalProvider } from "./contexts/IntervalContext";
import App from "./App";
import API_BASE_URL from "config/api";
import { installGlobalSessionGuard } from "./utils/globalSessionGuard";

// ✅ 전역 클릭 감시 가드
installGlobalSessionGuard({
  verifyUrl: `${API_BASE_URL}/api/token/verify/`,
  redirectPath: "/sign-in",
  minIntervalMs: 8000,
  enableServerVerify: true,
});

ReactDOM.render(
  // <ThemeEditorProvider>
    <AuthProvider>
      <UserProvider>
        <IntervalProvider>
          {/* ✅ BrowserRouter로 App 감싸기 */}
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </IntervalProvider>
      </UserProvider>
    </AuthProvider>,
  // </ThemeEditorProvider>,
  document.getElementById("root")
);